import { createUseStyles } from '@glu/theming';

const styles = {
  root: {
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    padding: 0,
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    border: 0,
  },
};

export default createUseStyles(styles);
